import React from 'react';
import { ProductGroup } from '@/modules/Product/components/ProductGroup';
import { QuestionGroup } from '@/modules/Questionnaire/components/QuestionGroup';
import { Container } from '@/ui/layout';
import { sortWithNulls } from '@/utils/helpers';

const ENTITY_CONFIG = {
  product: {
    groupsKey: 'productGroups',
    GroupComponent: ProductGroup,
    groupPropName: 'productGroup'
  },
  questionnaire: {
    groupsKey: 'questionGroups',
    GroupComponent: QuestionGroup,
    groupPropName: 'questionGroup'
  }
};

export const EntitySection = ({ section, entityType = 'questionnaire', ...props }) => {
  const config = ENTITY_CONFIG[entityType];

  if (!config) {
    console.error(`Unknown entityType: ${entityType}`);
    return null;
  }

  const { groupsKey, GroupComponent, groupPropName } = config;
  const groups = section?.[groupsKey];

  if (!groups || !Array.isArray(groups)) {
    return null;
  }

  const sortedGroups = [...groups].sort((a, b) =>
    sortWithNulls(Number(a.sortOrder), Number(b.sortOrder))
  );

  return (
    <Container>
      {sortedGroups.map((group, index) => (
        <GroupComponent key={group.id || index} {...{ [groupPropName]: group }} {...props} />
      ))}
    </Container>
  );
};
